/**
 * Generated runtime TestId mirror for frontend/src/pages/AccessProfiles.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const AccessProfilesTestIds = {
  accessProfilesList: "access-profiles-list",
  btnCreateProfile: "btn-create-profile",
  colAutoAssignable: "col-auto-assignable",
  colCode: "col-code",
  colEnvironment: "col-environment",
  colName: "col-name",
  colRequestable: "col-requestable",
  colResource: "col-resource",
  colRisk: "col-risk",
  colStatus: "col-status",
  linkProfileDetail: (profile_id: string) => `link-profile-detail-${profile_id}`,
  linkProfileDetailPrefix: () => "link-profile-detail-" as TestIdPrefix
} as const;
